import TransactionConstants from '@common/constants/TransactionConstants';
import type { AllTransactionNumericInputInterface, IPropertyInfoModel, ITransactionNumericInputModel } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';
import { logError } from '@zg-rentals/log-error';

const addTermData = (transaction: ITransactionNumericInputModel, rentTerms: IPropertyInfoModel) => {
  const { tenantOnBoarded, tenantFirstName, tenantName, tenantEmail, termNotStarted, termEnded } = rentTerms;
  return {
    ...transaction,
    tenantOnBoarded,
    termNotStarted,
    termEnded,
    tenantFirstName,
    tenantName,
    tenantEmail,
    dueDate: formatTimestampToYMDString(transaction.dueDate),
    dateCreated: formatTimestampToYMDString(transaction.dateCreated),
    dateReceived: formatTimestampToYMDString(transaction.dateReceived),
    dateRequested: formatTimestampToYMDString(transaction.dateRequested),
    returnInitiatedDate: formatTimestampToYMDString(transaction.returnInitiatedDate),
  };
};

const addTermDataToTransactions = (
  transactions: Array<ITransactionNumericInputModel>,
  currentTerm: IPropertyInfoModel,
  nextTerm: IPropertyInfoModel,
) =>
  transactions.map((transaction) => {
    if (transaction.rentTermsKey === nextTerm.rentTermsKey) {
      return addTermData(transaction, nextTerm);
    }
    if (
      transaction.rentTermsKey === currentTerm.rentTermsKey ||
      transaction.ledgerGroup === TransactionConstants.LEDGER_GROUP.COMPLETED
    ) {
      return addTermData(transaction, currentTerm);
    }
    return null;
  });

export default (
  transactions: Array<ITransactionNumericInputModel>,
  currentTerm: IPropertyInfoModel,
  nextTerm: IPropertyInfoModel,
): AllTransactionNumericInputInterface => {
  const upcomingTransactions: Array<ITransactionNumericInputModel> = [];
  const completedTransactions: Array<ITransactionNumericInputModel> = [];
  const pastDueTransactions: Array<ITransactionNumericInputModel> = [];
  let upcomingTotal = 0;
  let pastDueTotal = 0;
  let completedTotal = 0;

  const newTransactions: any = addTermDataToTransactions(transactions, currentTerm, nextTerm);

  newTransactions.forEach((transaction: ITransactionNumericInputModel) => {
    if (transaction && transaction.ledgerGroup) {
      switch (transaction.ledgerGroup) {
        case TransactionConstants.LEDGER_GROUP.UPCOMING:
          upcomingTransactions.unshift(transaction);
          upcomingTotal += transaction.amount;
          break;
        case TransactionConstants.LEDGER_GROUP.PAST_DUE:
          pastDueTransactions.push(transaction);
          pastDueTotal += transaction.amount;
          break;
        case TransactionConstants.LEDGER_GROUP.COMPLETED:
          completedTransactions.push(transaction);
          completedTotal += transaction.amount;
          break;
        default:
          logError({
            error: new Error('Invalid transaction ledgerGroup'),
            context: {
              details: transaction,
            },
          });
          break;
      }
    }
  });

  return {
    upcomingTransactions,
    completedTransactions,
    pastDueTransactions,
    upcomingTotal,
    completedTotal,
    pastDueTotal,
  };
};
